import { handleApi } from '../../common';

const API_ENDPOINTS = {
	transactionHistory: (transactionType = '', pageNo = 1, pageSize = 20) =>
		`/api/equity/api/eqm/funds/transactions?transaction_type=${transactionType}&page_no=${pageNo}&page_size=${pageSize}`,
	withdrawTransactionDetail: (id) =>
		`/api/equity/api/eqm/payout/request/${id}`,
	payinTransactionDetail: (id,status) =>
		`/api/equity/api/eqm/funds/payin/transactions/${id}?status=${status}`,
};
export const get_transaction_list = async (Api, payload = {}, token = '') => {
	const { transactionType = '', pageNo = 1, pageSize = 20 } = payload;
	const response = await Api.get(
		API_ENDPOINTS.transactionHistory(transactionType, pageNo, pageSize),
		token,
	);
	const result = handleApi(response);
	return result;
};

export const get_withdraw_transaction_detail = async (
	Api,
	payload = {},
	token = '',
) => {
	const { id = '' } = payload;
	const response = await Api.get(
		API_ENDPOINTS.withdrawTransactionDetail(id),
		token,
	);
	const result = handleApi(response);
	return result;
};

export const get_payin_transaction_detail = async (
	Api,
	payload = {},
	token = '',
) => {
	const { id = '',status } = payload;
	const response = await Api.get(
		API_ENDPOINTS.payinTransactionDetail(id,status),
		token,
	);
	const result = handleApi(response);
	return result;
};

export const get_load_more_transaction_list = async (Api, payload) => {
	const { url } = payload;
	const data = await Api.get(url);
	return handleApi(data);
};
